<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  error: { type: String, default: '' },
  // Nome no título: quem confirma precisa saber qual segmento vai sumir
  segmentName: { type: String, default: '' },
});
const emit = defineEmits(['delete']);

const FILTER_TYPE_CONTACT = 'contact';

const { t } = useI18n();

const uiFlags = useMapGetter('customViews/getUIFlags');
const isDeleting = computed(() => uiFlags.value.isDeleting);

const dialogRef = ref(null);

const handleDialogConfirm = () => {
  if (isDeleting.value) return;
  emit('delete', {
    filterType: FILTER_TYPE_CONTACT,
  });
};

const requestClose = () => {
  if (!isDeleting.value) dialogRef.value?.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="
      t('CONTACTS_LAYOUT.HEADER.ACTIONS.FILTERS.DELETE_SEGMENT.TITLE', {
        name: segmentName,
      })
    "
    :description="
      t('CONTACTS_LAYOUT.HEADER.ACTIONS.FILTERS.DELETE_SEGMENT.DESCRIPTION')
    "
    :confirm-button-label="
      t('CONTACTS_LAYOUT.HEADER.ACTIONS.FILTERS.DELETE_SEGMENT.CONFIRM')
    "
    :is-loading="isDeleting"
    :disable-confirm-button="isDeleting"
    :show-cancel-button="!isDeleting"
    confirm-before-close
    @request-close="requestClose"
    @confirm="handleDialogConfirm"
  >
    <p v-if="error" role="alert" class="m-0 text-sm text-n-ruby-11">
      {{ error }}
    </p>
  </Dialog>
</template>
